import { Link } from "react-router-dom";
import { Camera, ArrowRight } from "lucide-react";
import SeoHead from "../components/SeoHead";
import CTABand from "../components/CTABand";
import { PageHeader } from "./Services";
import { SITE } from "../lib/site";

// Photos issues du site officiel termitehabitat33.fr (référencement)
const PHOTOS = [
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/1704443571336.jpeg", alt: "Poutre attaquée par les termites — chantier Gironde", cat: "Termites" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/IMG_20230522_114323-scaled.jpg", alt: "Piège termites posé", cat: "Pièges" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/IMG_20230522_114253-scaled.jpg", alt: "Pose d'un piège termites en périmètre", cat: "Pièges" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/Screenshot_20240104_100703_Gallery-scaled.jpg", alt: "Cordonnets de termites sur mur", cat: "Expertise" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/1704443571353.jpeg", alt: "Bois contaminé par les termites", cat: "Termites" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/1704443598581.jpeg", alt: "Mise en place d'un piège anti-termites", cat: "Pièges" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/1704443598549.jpeg", alt: "Poutre entièrement dégradée par les termites", cat: "Termites" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/1704443598598.jpeg", alt: "Poutre ravagée — traces de cordonnets visibles", cat: "Expertise" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/IMG_20230522_111805-scaled.jpg", alt: "Brûlage de bois contaminé sur chantier", cat: "Traitement" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/1704443598563.jpeg", alt: "Termites volantes — essaimage", cat: "Termites" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/received_152931557633662.jpeg", alt: "Pièges posés chez un client Gironde", cat: "Pièges" },
  { src: "https://termitehabitat33.fr/wp-content/uploads/2024/01/received_1534180993737347.jpeg", alt: "Termites et termites volantes capturés", cat: "Termites" },
];

export default function Galerie() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ImageGallery",
    name: "Photos chantiers Termite Habitat 33",
    description: "Galerie de chantiers réels de traitement termites en Gironde.",
    image: PHOTOS.map((p) => ({
      "@type": "ImageObject",
      contentUrl: p.src,
      caption: p.alt,
    })),
  };

  return (
    <div data-testid="galerie-page">
      <SeoHead
        title="Galerie chantiers termites Bordeaux & Gironde | Termite Habitat 33"
        description="Photos de chantiers réels Termite Habitat 33 : termites, pièges‑appâts, charpentes traitées, cordonnets, essaimages en Gironde."
        canonical={SITE.url + "/galerie"}
        keywords={["photos termites Bordeaux", "chantier termites Gironde", "avant après termites"]}
        breadcrumbs={[
          { name: "Accueil", url: SITE.url + "/" },
          { name: "Galerie", url: SITE.url + "/galerie" },
        ]}
        schema={schema}
      />
      <PageHeader
        eyebrow="Galerie chantiers"
        title="Nos interventions en images."
        intro="Photos issues de chantiers réels menés en Gironde par Termite Habitat 33 : termites en action, cordonnets, pièges-appâts posés, charpentes traitées et bois contaminés brûlés sur place."
      />

      <section className="container-x py-12" data-testid="galerie-grid">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PHOTOS.map((p, i) => (
            <figure
              key={i}
              className="group relative overflow-hidden border border-[#D5CABD] bg-white"
              data-testid={`galerie-item-${i}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="p-4">
                <div className="text-[10px] uppercase tracking-widest text-[#7A2E39] mb-1">
                  {p.cat}
                </div>
                <div className="text-sm text-gray-800">{p.alt}</div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 max-w-2xl mx-auto text-center">
          <Camera className="w-10 h-10 text-[#7A2E39] mx-auto mb-3" />
          <p className="text-gray-700 mb-4">
            Toutes ces interventions sont menées en Bordeaux Métropole et en Gironde par notre équipe
            certifiée. Pour une expertise chez vous, demandez un devis gratuit en ligne.
          </p>
          <Link
            to="/devis"
            className="btn-primary"
            data-testid="galerie-devis-link"
          >
            Demander un devis gratuit <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
